module.exports = __webpack_public_path__ + "static/media/gr.d25ffd84.svg";